module.exports = __webpack_public_path__ + "static/img/1.06b3286.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/sp/1.png
// module id = EY1E
// module chunks = 0